import React, { Component } from 'react'
import { RouteComponentProps } from 'react-router-dom'

import PageLayout from 'components/layout/pageLayout'
import SubNavigation from 'components/layout/subNavigation'
import Head from 'components/layout/head'

interface TermsOfUseAbkProps extends RouteComponentProps<any> {
  authenticated: boolean
  dispatch: any
}

type TermsOfUseAbkState = {}

class TermsOfUseAbk extends Component<TermsOfUseAbkProps, TermsOfUseAbkState> {
  constructor(props: TermsOfUseAbkProps) {
    super(props)
    this.state = {}
  }

  render() {
    return (
      <PageLayout pageTitle="FAQ">
        <Head
          headline="FAQ"
          subheadline="ABK calcKit – der Baukasten für die schnelle Kalkulation"
        />
        <SubNavigation
          items={[
            {
              label: 'Nutzungsbedingungen',
              link: '/faq/terms-of-use',
            },
            {
              label: 'Tutorial',
              link: '/faq/tutorial',
            },
            {
              label: 'Links',
              link: '/faq/links',
            },
          ]}
        />
        <div className="px-48 mb-65">
          <p className="font-400 text-black text-15 tracking-0.1 leading-22">
            (1) Dieses Programm wurde unter Berücksichtigung des bei Erstellung im Jahr 2020
            aktuellen Standes der einschlägigen Technik sorgfältig programmiert und die im Programm
            enthaltenen Produktdaten ebenfalls sorgfältig zusammengestellt. Die ib-data GmbH
            (nachfolgend „ib-data“ genannt) übernimmt jedoch keine Garantie für die Richtigkeit,
            Vollständigkeit und Aktualität der im Programm bereitgestellten Inhalte. Des Weiteren
            übernimmt ib-data keine Gewähr oder Garantie dafür, dass das Programm für die konkreten
            Bedürfnisse des Nutzers geeignet ist, es sei denn, der Programmnutzer hat diese
            konkreten Bedürfnisse ib-data schriftlich oder per E-Mail mitgeteilt und daraufhin von
            ib-data die ausdrückliche Bestätigung der Geeignetheit erhalten. Ausgenommen im
            letztgenannten Fall wählt der Programmnutzer die Inhalte des Programms deshalb
            eigenverantwortlich aus und verwendet sie auch eigenverantwortlich. Jegliche Gewähr oder
            Haftung von ib-data für eine unrichtige oder nicht bestimmungsgemäße Verwendung der
            Inhalte des Programms ist ausgeschlossen.
          </p>
          <br />
          <p className="font-400 text-black text-15 tracking-0.1 leading-22">
            (2) Gegen ib-data gerichtete Ansprüche des Programmnutzers auf Schadenersatz gleich aus
            welchem Rechtsgrund, welche aus der Programmnutzung resultieren und die ein Verschulden
            von ib-data erfordern, sind ausgeschlossen, es sei denn, der Schaden beruht auf einer
            vorsätzlichen oder grob fahrlässigen Pflichtverletzung von ib-data, eines gesetzlichen
            Vertreters von ib-data oder eines Erfüllungsgehilfen von ib-data.
          </p>
          <br />
          <p className="font-400 text-black text-15 tracking-0.1 leading-22">
            (3) Soweit es sich um eine ib-data zurechenbare Verletzung von wesentlichen Pflichten
            handelt, die aus einem zwischen ib-data und dem Programmnutzer aufgrund der
            Programmnutzung entstehenden Schuldverhältnis resultieren, und soweit diese Verletzung
            auf einfacher Fahrlässigkeit von ib-data, eines gesetzlichen Vertreters von ib-data oder
            eines Erfüllungsgehilfen von ib-data beruht, ist die Haftung von ib-data beschränkt auf
            vertragstypische und vorhersehbare Schäden. Als solche wesentliche Pflichten gelten
            sowohl Leistungspflichten gemäß § 241 Abs. 2 BGB als auch Pflichten gemäß § 241 Abs. 2
            BGB, die für den Programmnutzer von erheblicher Bedeutung sind.
          </p>
          <br />
          <p className="font-400 text-black text-15 tracking-0.1 leading-22">
            (4) Bei einer ib-data zurechenbaren Verletzung von nicht wesentlichen Pflichten gemäß §
            241 Abs. 1 oder Abs. 2 BGB, die aus einem zwischen ib-data und dem Programmnutzer
            aufgrund der Programmnutzung entstehenden Schuldverhältnis resultieren, gelten die in
            Absatz 2 enthaltenen Haftungsausschlüsse, wobei einer solchen Pflichtverletzung von
            ib-data diejenige eines gesetzlichen Vertreters von ib-data oder eines
            Erfüllungsgehilfen von ib-data gleichsteht.
          </p>
          <br />
          <p className="font-400 text-black text-15 tracking-0.1 leading-22">
            (5) Die in Absatz 1 und 2 enthaltenen Haftungsausschlüsse und die in Absatz 3 geregelte
            Haftungsbeschränkung gelten nicht im Fall der Übernahme ausdrücklicher Garantien durch
            ib-data und nicht für solche Schäden, die auf eine Verletzung des Lebens, des Körpers
            oder der Gesundheit zurückzuführen sind, soweit die jeweilige Verletzung auf einer
            vorsätzlichen oder fahrlässigen Pflichtverletzung von ib-data, eines gesetzlichen
            Vertreters von ib-data oder eines Erfüllungsgehilfen von ib-data beruht.
          </p>
          <br />
          <p className="font-400 text-black text-15 tracking-0.1 leading-22">
            (6) Ob aufgrund der Programmnutzung ein Schuldverhältnis zwischen dem Programmnutzer und
            ib-data entsteht, richtet sich nach den Umständen des Einzelfalls, wobei im Regelfall
            bei schlichter Programmnutzung kein Schuldverhältnis zustande kommt, es sei denn, es
            liegen besonderen Umstände vor, welche über die schlichte Programmnutzung hinausgehen.
          </p>
          <br />
          <p className="font-400 text-black text-15 tracking-0.1 leading-22">
            (7) Da es sich bei den angegebenen Preisen um unverbindliche Preisempfehlungen der
            ib-data handelt, können die tatsächlich im Markt existierenden Preise teilweise
            erheblich davon abweichen. Es obliegt dem Programmnutzer, sich rechtzeitig beim
            Fachhandel über die jeweils aktuellen Preise zu informieren.
          </p>
          <br />
          <br />

          <h2 className="mb-15 text-20 leading-22 tracking-0.23 font-500 text-black">
            HAFTUNGSAUSSCHLUSS
          </h2>
          <p className="font-400 text-black text-15 tracking-0.1 leading-22">
            Dieses Programm wurde sorgfältig programmiert und die Produktdaten sorgfältig
            zusammengestellt. Dennoch haftet ib-data nicht für Schäden infolge der Benutzung des
            Programms. Insbesondere ist jede Haftung für Schäden (z. B. eine fehlerhafte Planung)
            ausgeschlossen, die durch Verwendung von Berechnungsergebnissen oder von Daten oder
            Informationen aus dem Programm verursacht wurden. Der Haftungsausschluss gilt nicht für
            Schäden aus der Verletzung von Leben, Körper und Gesundheit sowie für Schäden, die auf
            einer vorsätzlichen oder grob fahrlässigen Pflichtverletzung von ib-data oder auf einer
            vorsätzlichen oder grob fahrlässigen Pflichtverletzung eines gesetzlichen Vertreters
            oder Erfüllungsgehilfen von ib-data beruhen.
          </p>
        </div>
      </PageLayout>
    )
  }
}

export default TermsOfUseAbk
